import { render, staticRenderFns } from "./106.vue?vue&type=template&id=a0b01068&scoped=true&"
var script = {}
import style0 from "./106.vue?vue&type=style&index=0&id=a0b01068&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b01068",
  null
  
)

export default component.exports